module.exports = __webpack_public_path__ + "static/media/housekeep.1f2f2922.png";